import React from 'react'
import { Box } from '@mui/material'
import { EmtIcon, EmtTypography, useMobile } from 'emt-components-v2'
import LinkButton from '@/components/EMT/LinkButton'
import PetSitterCard from '@/components/PetSitter/PetSitterCard/PetSitterCard'
import { Routes } from '@/assets/configs'
import { useIsQueryOwner } from '@/hooks'

// API
import { useQuery } from '@tanstack/react-query'
import { FiltersValues, getSearchAsync } from '@/modules/PetSitter/searchServiceHelper'
import useFloatingProfile from '@/hooks/useFloatingProfile'

type Props = {
  handleOpenProfile: ReturnType<typeof useFloatingProfile>['handleOpenProfile']
}

export const NewPetSitters: React.FC<Props> = ({ handleOpenProfile }) => {
  const [isMobile] = useMobile()
  const [, , appendQueryType] = useIsQueryOwner()

  const filters: FiltersValues = {
    sortBy: 'recommender',
    address: null,
    distance: {
      min: 0,
      max: 20,
    },
  }

  const { data: petSitters } = useQuery(['petSitters'], () => getSearchAsync(filters, 1, 4))

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <EmtTypography variant="body1">
          Super Sitters est le seul service de mise en relation avec des pet sitters à faire passer des{' '}
          <span style={{ color: '#0030CC' }}>tests psychologiques</span> et des{' '}
          <span style={{ color: '#C80068' }}>tests de compétences</span> pour sélectionner les meilleurs pet sitters.
          Nous ne gardons que ceux en qui nous aurions confiance pour nos propres animaux.
        </EmtTypography>
        <EmtTypography variant="h4" fontWeight={800}>
          Pet sitters proches
        </EmtTypography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '20px 25px' }}>
          {petSitters &&
            petSitters?.['hydra:member']?.map((sitter, index) => (
              <PetSitterCard
                buttonVariant="outlined"
                key={sitter?.id || index}
                data={sitter}
                seeProfile
                onMobileNavigate={handleOpenProfile}
              />
            ))}
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <LinkButton
            href={appendQueryType(Routes.PetSitter.Search)}
            fullWidth={isMobile}
            startIcon={<EmtIcon className="emt-search-1" />}
            color="purple"
          >
            Voir tous les pet sitters
          </LinkButton>
        </Box>
      </Box>
    </>
  )
}
